import logo from './assets/mynah.jpg';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import './css/styles.css';
import { BudgetGroups } from './budgethelper/budgetGroups';
import { wrapAuth } from './auth/authWrapper';
import { ExpenseTracker } from './budgethelper/expenseTracker';
import { ProfilePage } from './profilepage/profilepage';
import { ContactPage } from './profilepage/contactpage';

export function loader() {
  return Response.json({ version: "52" });
}

const MynahHeader = () => <header className="App-header">
    <img src={logo} className="App-logo" alt="logo" />
    <p>
      The Cutest Bird on the Planet!!``
    </p>
  </header>;

export function App() {
  const WrappedExpenseTracker = wrapAuth(ExpenseTracker);
  const WrappedBudgetGroups = wrapAuth(BudgetGroups);
  
  return (
    <div className="App">
        <Router>
          <Routes>
            <Route path='/' element={<MynahHeader/>} />
            <Route path="/expense-tracker" element={<WrappedExpenseTracker />} />
            <Route path="/budget-groups" element={<WrappedBudgetGroups />} />
            <Route path="/sample-profile/" element={<ProfilePage/>}/>
            <Route path="/sample-profile/contact-us" element={<ContactPage/>}/>
          </Routes>
        </Router>
      </div>
  );
}
